import { useState, useEffect } from "react";
import { useAuthenticate } from "../context/AuthContext";
import axios from "axios";
import { api_url } from "../utils/data";
import { toast } from "react-toastify";

export const useChartData = (initialData = null) => {
  const { authToken } = useAuthenticate();
  const [chartData, setChartData] = useState(null);
  const [gettingData, setGettingData] = useState(false);

  // Initialize chart data on mount if initialData is provided
  useEffect(() => {
    if (initialData) {
      setChartData(createChartData({ data: initialData }));
    }
  }, [initialData]);

  const createChartData = (response) => ({
    labels: response.data?.labels || [],
    datasets: [
      {
        label: "Sales",
        data: response.data?.sales_report?.map((data) => data?.amount) || 
              response.data?.order_statistics?.map((data) => data?.amount) || [],
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  });

  const handleChartError = (error) => {
    setGettingData(false);
    toast.error("Failed to get data");
    console.error(error);
  };

  const getMonthData = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    
    setGettingData(true);
    try {
      const response = await axios.get(`${api_url}/sales/sale-report/month`, config);
      setChartData(createChartData(response));
      setGettingData(false);
    } catch (error) {
      handleChartError(error);
    }
  };

  const getYearData = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    
    setGettingData(true);
    try {
      const response = await axios.get(`${api_url}/sales/sale-report/year`, config);
      setChartData(createChartData(response));
      setGettingData(false);
    } catch (error) {
      handleChartError(error);
    }
  };

  const getWeekData = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    
    setGettingData(true);
    try {
      const response = await axios.get(`${api_url}/sales/sale-report/week`, config);
      setChartData(createChartData(response));
      setGettingData(false);
    } catch (error) {
      handleChartError(error);
    }
  };

  // Initialize with default data if needed
  const initializeChart = (initialData) => {
    if (initialData) {
      setChartData(createChartData({ data: initialData }));
    }
  };

  return {
    chartData,
    gettingData,
    getMonthData,
    getYearData,
    getWeekData,
    initializeChart
  };
};